import { state } from "../context/store";

const closePopups = (e) => {
  // console.log(e);
  e.stopPropagation();
  state.current.modal.open = false;
  state.current.modal.bottomAlign = false;
  state.current.modal.clearBackground = false;
  state.current.modal.instructions = false;
  state.current.modal.disclaimer = false;
  state.current.modal.resetCustomisation = false;
  state.current.modal.exitApp = false;
  state.current.modal.cameraControls = false;
  state.current.modal.orderSummary = false;
  state.current.modal.selectModel = false;
  state.current.modal.settingNumber = false;
  state.current.modal.orderConfirmed = false;
  state.current.modal.emptyCart = false;
  state.current.modal.superBadge = false;
  state.current.modal.multiRib = false;
  state.current.status.confirmLeave = false;
  state.current.status.confirmResetDesign = false;
  state.current.status.confirmRemoveNumber = false;
  state.current.status.numberSelectMode = "number";
  state.current.status.confirmResetRibs = false;
};

export default closePopups;
